<template>
    <div>
        <v-row>
            <v-col cols="6" class="my-5">
                <button class="button back-to-list" @click="backToList">
                    <v-icon>mdi-arrow-left</v-icon>
                    <span class="text">Back To List</span>
                </button>
            </v-col>
            <v-col
                v-if="isImageGenerated !== null && !!id && can('astm-devices.download')"
                cols="6"
                class="text-right my-5"
            >
                <v-btn
                    v-if="!!isImageGenerated"
                    color="primary"
                    rounded
                    relative
                    top
                    right
                    class="ml-4 download-os-image"
                    @click="$root.goTo(downloadImageUrl())"
                >
                    <v-icon>mdi-download</v-icon>
                    <span>{{ t('astm-devices::button.download-os-image') }}</span>
                </v-btn>
                <span v-if="!!!isImageGenerated" class="text-warning font-weight-bolder">
                    <v-icon color="#ffc107">mdi-alert</v-icon>
                    {{ t('astm-devices::form.label.image_not_generated') }}
                </span>
            </v-col>
        </v-row>
        <v-col cols=" 12">
            <h2>{{ t('astm-devices::page.title.astm_device') }}</h2>
        </v-col>
        <v-col cols="12">
            <div class="form-wrapper">
                <v-form autocomplete="off">
                    <v-col cols="12" xl="10" class="px-0">
                        <v-row>
                            <v-col cols="12">
                                <h5>{{ t('astm-devices::form.title.general_information') }}</h5>
                            </v-col>
                            <v-col cols="12" lg="4" class="pt-0">
                                <b-input
                                    to-mutate="astm_devices::astm_device.name"
                                    :label="t('astm-devices::form.label.device_id')"
                                    :rules="validationRules.name"
                                    :readonly="readOnlyRules"
                                    mandatory
                                ></b-input>
                            </v-col>
                            <v-col cols="12" lg="4" class="pt-0">
                                <b-select
                                    to-mutate="astm_devices::astm_device.pharmacy_site_id"
                                    :label="t('astm-devices::form.label.pharmacy_site')"
                                    :select-items="pharmacySitesOptions"
                                    :rules="validationRules.pharmacy_site_id"
                                    item-value="id"
                                    item-text="name"
                                    clearable
                                    mandatory
                                    :readonly="readOnlyRules"
                                    component-name="v-autocomplete"
                                ></b-select>
                            </v-col>
                            <v-col cols="12" lg="4" class="pt-0">
                                <b-input
                                    to-mutate="astm_devices::astm_device.prn"
                                    :label="t('collection-centre::form.label.prn')"
                                    :readonly="readOnlyRules"
                                ></b-input>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <h5>{{ t('astm-devices::form.title.connection_settings') }}</h5>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <h6>{{ t('astm-devices::form.title.device') }}</h6>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12" lg="6">
                                <b-input
                                    to-mutate="astm_devices::astm_device.proxy_mac_address"
                                    :label="t('astm-devices::form.label.proxy_mac_address')"
                                    :hint="t('astm-devices::form.hint.proxy_mac_address')"
                                    persistent-hint
                                    :readonly="readOnlyRules"
                                    :rules="validationRules.proxy_mac_address"
                                    :disabled="!!id"
                                    mandatory
                                ></b-input>
                            </v-col>
                            <v-col cols="12" md="12" lg="6">
                                <b-select
                                    to-mutate="astm_devices::astm_device.network_method"
                                    :label="t('astm-devices::form.label.network_method')"
                                    :select-items="networkMethodOptions"
                                    :rules="validationRules.network_method"
                                    :readonly="readOnlyRules"
                                    :disabled="!!id"
                                    clearable
                                    mandatory
                                >
                                </b-select>
                            </v-col>
                        </v-row>
                        <v-row v-if="$store.state.astm_devices.astm_device.network_method === 'manual'">
                            <v-col cols="12">
                                <h6>{{ t('astm-devices::form.title.wan_settings') }}</h6>
                            </v-col>
                        </v-row>
                        <v-row v-if="$store.state.astm_devices.astm_device.network_method === 'manual'">
                            <v-col cols="12" md="12" lg="6" class="pb-0">
                                <b-input
                                    to-mutate="astm_devices::astm_device.ip_address_mask"
                                    :label="t('astm-devices::form.label.ip_address_mask')"
                                    :hint="t('astm-devices::form.hint.ip_address_mask')"
                                    mandatory
                                    persistent-hint
                                    :readonly="readOnlyRules"
                                    :disabled="!!id"
                                ></b-input>
                            </v-col>
                            <v-col cols="12" md="12" lg="6" class="pb-0">
                                <b-input
                                    to-mutate="astm_devices::astm_device.ip_gate"
                                    :label="t('astm-devices::form.label.ip_gate')"
                                    mandatory
                                    :readonly="readOnlyRules"
                                    :disabled="!!id"
                                ></b-input>
                            </v-col>
                            <v-col cols="12" md="12" lg="6" class="pb-0">
                                <b-input
                                    to-mutate="astm_devices::astm_device.ip_dns"
                                    :label="t('astm-devices::form.label.ip_dns')"
                                    mandatory
                                    :readonly="readOnlyRules"
                                    :disabled="!!id"
                                ></b-input>
                            </v-col>
                            <v-col cols="12" md="12" lg="6" class="pb-0">
                                <b-input
                                    to-mutate="astm_devices::astm_device.proxy_ip_address"
                                    :label="t('astm-devices::form.label.proxy_ip_address')"
                                    mandatory
                                    :readonly="readOnlyRules"
                                    :disabled="!!id"
                                ></b-input>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <h6>{{ t('astm-devices::form.title.lan_settings') }}</h6>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="12" lg="6" class="pb-0">
                                <b-input
                                    to-mutate="astm_devices::astm_device.ip_address_mask_two"
                                    :label="t('astm-devices::form.label.ip_address_mask_two')"
                                    :readonly="readOnlyRules"
                                    :rules="validationRules.ip_address_mask_two"
                                    :hint="t('astm-devices::form.hint.ip_address_mask_two')"
                                    persistent-hint
                                    :disabled="!!id"
                                    mandatory
                                ></b-input>
                            </v-col>
                            <v-col cols="12" md="12" lg="6" class="pb-0">
                                <b-input
                                    to-mutate="astm_devices::astm_device.listening_port"
                                    :label="t('astm-devices::form.label.listening_port')"
                                    :readonly="readOnlyRules"
                                    :rules="validationRules.listening_port"
                                    :disabled="!!id"
                                    mandatory
                                ></b-input>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="12" lg="6" class="pb-0">
                                <b-input
                                    to-mutate="astm_devices::astm_device.analyzer_name"
                                    :label="t('astm-devices::form.label.analyzer_name')"
                                    :readonly="readOnlyRules"
                                    :rules="validationRules.analyzer_name"
                                    mandatory
                                ></b-input>
                            </v-col>
                            <v-col cols="12" md="12" lg="6" class="pb-0">
                                <b-input
                                    :label="t('astm-devices::form.label.analyzer_ip')"
                                    to-mutate="astm_devices::astm_device.analyzer_ip"
                                    :hint="t('astm-devices::form.hint.analyzer_ip')"
                                    persistent-hint
                                    :readonly="readOnlyRules"
                                    :disabled="!!id"
                                ></b-input>
                            </v-col>
                            <v-col cols="12" md="12" lg="6" class="pb-0">
                                <b-input
                                    :label="t('astm-devices::form.label.analyzer_serial')"
                                    to-mutate="astm_devices::astm_device.analyzer_serial"
                                    :readonly="readOnlyRules"
                                    :disabled="!!id"
                                ></b-input>
                            </v-col>
                        </v-row>

                        <!-- Auth -->
                        <v-row>
                            <v-col cols="12">
                                <h6>{{ t('astm-devices::form.title.authentication') }}</h6>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="12" lg="6" class="pb-0">
                                <b-input
                                    to-mutate="astm_devices::astm_device.user.username"
                                    :readonly="readOnlyRules"
                                    :disabled="!!id"
                                    type="username"
                                    :label="t('astm-devices::form.label.user')"
                                    :rules="validationRules.username"
                                    autocomplete="off"
                                    mandatory
                                ></b-input>
                            </v-col>
                            <v-col cols="12" md="12" lg="6" class="pb-0">
                                <b-input
                                    to-mutate="astm_devices::astm_device.user.password"
                                    :readonly="readOnlyRules"
                                    :disabled="!!id"
                                    type="password"
                                    autocomplete="off"
                                    :label="t('astm-devices::form.label.password')"
                                    :rules="!id ? validationRules.password : []"
                                    mandatory
                                ></b-input>
                            </v-col>
                        </v-row>
                        <!-- /Auth -->

                        <v-row>
                            <v-col cols="12">
                                <h6>{{ t('astm-devices::form.title.vpn_settings') }}</h6>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="12" lg="6" class="pb-0">
                                <b-input
                                    to-mutate="astm_devices::astm_device.open_vpn_username"
                                    :readonly="true"
                                    :disabled="!!id || !manualMode"
                                    type="username"
                                    :label="t('astm-devices::form.label.open_vpn_user')"
                                    :rules="validationRules.username"
                                    autocomplete="off"
                                    mandatory
                                ></b-input>
                            </v-col>
                            <v-col cols="12" md="12" lg="6" class="pb-0">
                                <b-input
                                    to-mutate="astm_devices::astm_device.open_vpn_pass"
                                    :readonly="readOnlyRules"
                                    :disabled="!!id || !manualMode"
                                    type="password"
                                    autocomplete="off"
                                    :label="t('astm-devices::form.label.open_vpn_pass')"
                                    :rules="!id ? validationRules.password : []"
                                    :mandatory="!!manualMode"
                                ></b-input>
                            </v-col>
                        </v-row>

                        <v-row class="pt-5">
                            <!-- <v-col cols="12" lg="4">
                                <v-btn
                                    depressed
                                    color="primary"
                                    outlined
                                    class="test-connection-button"
                                    rounded
                                    block
                                    :loading="testConnectionLoading"
                                    @click="testConnection"
                                >
                                    {{ t('astm-devices::btn.establish_connection') }}
                                </v-btn>
                            </v-col> -->
                            <v-col cols="12" lg="3">
                                <div class="astm-status">
                                    <label>{{ t('astm-devices::form.label.status') }}</label>
                                    <div class="grid-status">
                                        <div class="grid-status-border"></div>
                                        <span>
                                            {{
                                                status
                                                    ? t('astm-devices::status.online')
                                                    : t('astm-devices::status.offline')
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </v-col>

                            <v-col cols="12" lg="3">
                                <div class="astm-status">
                                    <label>{{ t('astm-devices::form.label.openvpn-status') }}</label>
                                    <div class="grid-status">
                                        <div class="grid-status-border"></div>
                                        <span>
                                            {{ t('astm-devices::openvpn-status.' + openVPNStatus) }}
                                        </span>
                                    </div>
                                </div>
                            </v-col>

                            <v-col cols="12">
                                <div class="d-flex align-items-center">
                                    <p class="mr-3 pt-5">{{ t('astm-devices::form.label.block_device') }}</p>
                                    <b-switch to-mutate="astm_devices::astm_device.authorized" :label="''"></b-switch>
                                    <p class="ml-3 pt-5">{{ t('astm-devices::form.label.authorise_device') }}</p>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <astm-device-actions @reloadAstmDevice="backToList"></astm-device-actions>
                </v-form>
            </div>
        </v-col>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            testConnectionLoading: false,
            validationRules: {
                name: [(v) => !!v || t('users::validation.field.required')],
                pharmacy_site_id: [(v) => !!v || t('users::validation.field.required')],
                proxy_mac_address: [(v) => !!v || t('users::validation.field.required')],
                ip_address_mask_two: [(v) => !!v || t('users::validation.field.required')],
                listening_port: [(v) => !!v || t('users::validation.field.required')],
                analyzer_name: [(v) => !!v || t('users::validation.field.required')],
                network_method: [(v) => !!v || t('users::validation.field.required')],
                username: [(v) => !!v || t('users::validation.field.required')],
                password: [(v) => !!v || t('users::validation.field.required')],
            },
            networkMethodOptions: [
                { value: 'manual', text: t('astm-devices::options.network_method.manual') },
                { value: 'dhcp', text: t('astm-devices::options.network_method.dhcp') },
            ],
            manualMode: true,
        };
    },
    computed: {
        pharmacySitesOptions() {
            return this.$store.state.astm_devices.pharmacySitesOptions;
        },
        status() {
            return this.$store.state.astm_devices.astm_device.active;
        },
        openVPNStatus() {
            return this.$store.state.astm_devices.astm_device.open_vpn_status;
        },
        isImageGenerated() {
            return this.$store.state.astm_devices.image_status;
        },
        readOnlyRules() {
            if (this.id && this.can('api.v1.collection-centres.update')) {
                return false;
            }
            if (!this.id && this.can('api.v1.collection-centres.store')) {
                return false;
            }
            return (
                (!this.can('api.v1.collection-centres.update') || !this.can('api.v1.collection-centres.store')) &&
                this.can('api.v1.collection-centres.show')
            );
        },
    },
    created() {
        this.$store.dispatch('astm_devices/loadPharmacySitesOptions');
        this.loadAstmDevice();
        this.loadConfig();
    },
    mounted() {
        this._repairAutocomplete();
    },
    methods: {
        testConnection() {
            this.testConnectionLoading = true;
            this.$root.notify('warning', '#TODO', '#TODO');
            // promise;
            _.delay(() => (this.testConnectionLoading = false), 1400);
        },
        backToList() {
            return this.$root.goTo(route('astm-devices.index'));
        },
        downloadImageUrl() {
            return route('astm-devices.download', {
                astm_device: this.id,
            });
        },
        loadConfig() {
            axios
                .get(route('api.v1.astm-devices.config'))
                .then((response) => {
                    this.manualMode = response.data.manual_mode;
                })
                .catch(() => {});
        },
        loadAstmDevice() {
            if (_.isEmpty(this.id)) {
                this.loading = false;
                return;
            }
            this.loading = true;
            axios
                .get(
                    route('api.v1.astm-devices.show', {
                        astm_device: this.id,
                        fields: '*,user',
                    })
                )
                .then((response) => {
                    const data = response.data.data;
                    this.$store.dispatch('astm_devices/loadAstmDevice', data);
                })
                .catch((error) => {
                    this.$root.notify('error', error.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        _repairAutocomplete() {
            const el = this.$el;
            el.querySelectorAll('input').forEach((it) => {
                switch (it.type) {
                    case 'username':
                        it.setAttribute('autocomplete', 'new-username');
                        break;
                    case 'password':
                        it.setAttribute('autocomplete', 'new-password');
                        break;
                    default:
                        break;
                }
            });
        },
    },
};
</script>
